// @flow
import React from "react"
import { css } from "react-emotion"
import { color, mq } from "../../styles/variables"

export function Form({
  title,
  description,
  connection_card,
}: {
  title: string,
  description: string,
  connection_card: string,
}) {
  return (
    <div id="mc_embed_signup" className="footer-form">
      <h4>{title}</h4>
      <p>{description}</p>
      <form
        action="https://spiritualliving.us12.list-manage.com/subscribe/post?u=94bc1910157fb1fc247d87f51&id=1ab2a558c0"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className="validate"
        target="_blank"
        noValidate
      >
        <div
          className={css`
            display: flex;
            justify-content: center;

            > div {
              display: flex;
              justify-content: center;
            }

            .mc-field-group {
              flex-grow: 2;
            }

            input {
              font-size: 14px;
              line-height: 2em;
              padding: 8px 10px;
              width: 100%;

              &:focus {
                outline: 1px solid ${color.rgb.orange[0]};
              }
            }

            ${mq.md(css`
              justify-content: flex-start;
              width: 100%;

              > div:first-of-type {
                flex-grow: 2;

                input {
                  width: 100%;
                }
              }
            `)}
          `}
        >
          <div className="mc-field-group">
            <input
              type="email"
              placeholder="E-MAIL ADDRESS"
              name="EMAIL"
              className="required email"
              id="mce-EMAIL"
            />
          </div>
          {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
          <div
            style={{ position: "absolute", left: "-5000px" }}
            aria-hidden="true"
          >
            <input
              type="text"
              name="b_94bc1910157fb1fc247d87f51_1ab2a558c0"
              tabIndex={-1}
            />
          </div>
          <div className="clear">
            <button
              className="btn btn-orange"
              type="submit"
              name="subscribe"
              id="mc-embedded-subscribe"
            >
              Sign-Up
            </button>
          </div>
        </div>
      </form>
      <p
        className={css`
          display: block;
        `}
      >
        Fill our online{" "}
        <a href="https://secure.spiritualliving.org/np/clients/spiritualliving/account.jsp">
          Connection Card
        </a>{" "}
        to share more about your interests.
      </p>
    </div>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer/Form.js